import { FC } from 'react';

import { ContentHeader, LoadingLayoutWrapper } from 'components';
import { useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { Stack } from 'libs/ui';

import { DirectoryItem } from '../components/DirectoryItem';

import { ContentStyled } from './styles';

export type DirectoriesViewProps = {
  loading?: boolean;
  directories?: {
    id: string;
    label: string;
  }[];
};

export const DirectoriesView: FC<DirectoriesViewProps> = ({
  directories,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <Stack flex={1} spacing={24}>
      <ContentHeader header={t('directory.directories.title')} />

      <LoadingLayoutWrapper loading={loading}>
        <ContentStyled datax="directories">
          {directories?.map((directory) => (
            <DirectoryItem
              key={directory.id}
              className="directory-item"
              datax={`directory-${directory.id}`}
              directory={directory}
            />
          ))}
          <DirectoryItem
            className="directory-item"
            datax="directory-Calendar"
            directory={{
              id: ROUTES.directories.productionCalendar.path,
              label: t('directory.productionCalendar.title'),
            }}
          />
        </ContentStyled>
      </LoadingLayoutWrapper>
    </Stack>
  );
};
